<template>
    <cp-select
        :config="routeCnae"
        item-value="id"
        clearable
        v-on="$listeners"
        v-bind="attrs"
        :customItem="true"
        :return-object="false"
    >
        <template v-slot:selection="{ item }">
            <span v-html="selected(item)"></span>
        </template>

        <template v-slot:item="{ item }">
            {{ `${item.code} - ${item.name}` }}
        </template>
    </cp-select>
</template>

<script>
import CpSelect from './Select'

export default {
    props: {
        routeCnae: {
            type: Object,
            required: false,
            default: () => {
                return { route: '/cnae' }
            },
        },
    },

    components: { CpSelect },

    computed: {
        attrs() {
            const { label, name, ...attrs } = this.$attrs

            return {
                ...{
                    label: label || 'Selecione uma opção',
                    name: name || 'select-cnae',
                },
                ...attrs,
            }
        },
    },

    methods: {
        selected(item) {
            return `${item.code} - ${item.name}`.length > 50
                ? `${item.code} - ${item.name}`.substring(0, 50) + '...'
                : `${item.code} - ${item.name}`
        },
    },
}
</script>
